/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...





function cartUpdate(){
         $.ajax({
            type: 'GET',
            url: '/cart',
            dataType: 'html',
            success: function(cartHtml) {
                    console.log(cartHtml);
                    let cartItemList =   $(cartHtml).find('.cart-drawer__item-list').html();
                    let cartItemFooter =  $(cartHtml).find('.cart-drawer__footer').html();
                    $('.cart-drawer__item-list').html(cartItemList);
                    $('.cart-drawer__footer').html(cartItemFooter);
                 
                      },
                  error: function(jqXHR, textStatus, errorThrown) {
                      console.error('Error refreshing cart drawer:', errorThrown);
                  }
              });
  
}


$(document).on('click', '.upsell-add-to-cart', function(event) {
    event.preventDefault();
  
    var variantId = $(this).data('variant-id');
 
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: variantId
        },
        dataType: 'json',
        success: function(data) {
            //console.log(data);
          cartUpdate();
         
           
        
        },
        error: function(jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 422) {
                console.log(jqXHR.responseText);
            }
        }
    });
});



 





 
  

